export var SourceBadgeType;
(function (SourceBadgeType) {
    SourceBadgeType["NCFTA"] = "ncfta";
    SourceBadgeType["AISAC"] = "aisac";
    SourceBadgeType["TRUSTAR"] = "trustar";
    SourceBadgeType["ALIENVAULT_OTX"] = "alienvault_otx";
    SourceBadgeType["CISCO_AMP_THREAT_GRID_INDICATOR_QUERY"] = "cisco_amp_threat_grid_indicator_query";
    SourceBadgeType["CISCO_AMP_THREAT_GRID_ANALYSIS_FEEDS"] = "cisco_amp_threat_grid_analysis_feeds";
    SourceBadgeType["CROWDSTRIKE_FALCON_DETECTION"] = "crowdstrike_falcon_detection";
    SourceBadgeType["CROWDSTRIKE_INDICATOR"] = "crowdstrike_indicator";
    SourceBadgeType["CROWDSTRIKE_REPORT"] = "crowdstrike_report";
    SourceBadgeType["DIGITAL_SHADOWS"] = "digital_shadows";
    SourceBadgeType["FACEBOOK_THREAT_EXCHANGE"] = "facebook_threat_exchange";
    SourceBadgeType["FB_THREAT"] = "fb_threat";
    SourceBadgeType["HYBRID_ANALYSIS"] = "hybrid_analysis";
    SourceBadgeType["H_ISAC"] = "h_isac";
    SourceBadgeType["IBM_XFORCE"] = "ibm_xforce";
    SourceBadgeType["INTEL_471_MALWARE_LIST"] = "intel471_malware_list";
    SourceBadgeType["JOE_SANDBOX"] = "joe_sandbox";
    SourceBadgeType["RECORDED_FUTURE_HASH_LIST"] = "recorded_future_hash_list";
    SourceBadgeType["RECORDED_FUTURE_IP_LIST"] = "recorded_future_ip_list";
    SourceBadgeType["RECORDED_FUTURE_URL_LIST"] = "recorded_future_url_list";
    SourceBadgeType["RECORDED_FUTURE_VULN_LIST"] = "recorded_future_vuln_list";
    SourceBadgeType["RISKIQ_BLACKLIST"] = "riskiq_blacklist";
    SourceBadgeType["VIRUSTOTAL"] = "virustotal";
    SourceBadgeType["ISIGHT"] = "isight";
    SourceBadgeType["URL_HAUS"] = "url_haus";
    SourceBadgeType["PHISHING"] = "phishing";
    SourceBadgeType["COVID19"] = "covid19";
    SourceBadgeType["UNKNOWN"] = "unknown";
})(SourceBadgeType || (SourceBadgeType = {}));
